export default {fields:{sources:{spreads:{NavStoreSource:{}},typenameResolver:'SourceTypenameResolver'}},typenameResolver:'QueryTypenameResolver'}